export enum SurveyState {
  draft = 'draft',
  running = 'running',
  finished = 'finished',
}
